import { render } from "./DiliPagination.vue?vue&type=template&id=71e7c989&scoped=true"
import script from "./DiliPagination.vue?vue&type=script&lang=ts"
export * from "./DiliPagination.vue?vue&type=script&lang=ts"

import "./DiliPagination.vue?vue&type=style&index=0&id=71e7c989&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-71e7c989"

export default script